import { RouteRecordRaw } from 'vue-router';
const ManualNotifications = () => import('@/pages/landings/manualNotifications.vue');
const ManagementModuleSelect = () => import('@/pages/management/modules/select.vue');

export const routes: RouteRecordRaw[] = [
    {
        path: '/landings/manual-notifications',
        name: 'manualNotificationsOld',
        component: ManualNotifications,
        meta: {
            layout: 'main',
            title: 'Ручная отправка готовых сообщений',
            hideHeader: true,
        },
    },
    {
        path: '/landings/:moduleIDOrAlias',
        name: 'manualNotifications',
        component: ManualNotifications,
        meta: {
            layout: 'main',
            title: 'Ручная отправка готовых сообщений',
            hideHeader: true,
        },
    },
    {
        path: '/landings/notifications/:moduleIDOrAlias',
        name: 'notificationsManualNotifications',
        component: ManualNotifications,
        meta: {
            layout: 'main',
            title: 'Ручная отправка готовых сообщений',
            hideHeader: true,
        },
    },
    {
        path: '/landings/notes/:moduleIDOrAlias',
        name: 'notes',
        component: ManagementModuleSelect,
        meta: {
            layout: 'main',
            hideHeader: true,
        },
    },
];

export default routes;
